import React, { FC } from 'react';
import { SurveyTemplatesListPage } from './survey-templates-list.page';

export const SurveyTemplateListDistrictLevelPage: FC = () => <SurveyTemplatesListPage isAdminRoute={false} />;
